import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  remove as removeUserRole
} from '../redux/userRoles'

export default function * requestRemoveUserRole (action) {
  const { userId, role } = action.payload

  const optimisticAction = yield optimisticPut(removeUserRole({
    userId,
    role,
  }))

  try {
    yield call(apiAction, 'RemoveUserRole', {
      userId,
      role,
    })
  } catch (error) {
    if (error.code !== 401) { // Not found
      throw error
    }
  } finally {
    yield optimisticAction.revert()
  }
}
